import { StandardQuizQuestion } from '@/types/quizTypes';

export const CLOUDFLARE_WORKERS_QUIZ: StandardQuizQuestion[] = [
  {
    id: "cf-workers-1",
    question: "What programming language can Cloudflare Workers execute?",
    options: [
      "Only Python",
      "JavaScript, TypeScript, Rust, C, C++",
      "Only PHP",
      "Only Go"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "Cloudflare Workers support JavaScript/TypeScript natively, and can run WebAssembly compiled from Rust, C, C++, and other languages.",
    category: "languages",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "cf-workers-2",
    question: "How many locations can a Cloudflare Worker run in?",
    options: [
      "One central location",
      "300+ edge locations globally",
      "Only US regions",
      "10 regional data centers"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "Cloudflare Workers deploy to 300+ edge locations in Cloudflare's global network, ensuring low latency by running close to users worldwide.",
    category: "deployment",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "cf-workers-3",
    question: "What is Workers KV?",
    options: [
      "A relational database",
      "A global, low-latency key-value data store",
      "A message queue",
      "A file storage system"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "Workers KV is an eventually-consistent, globally distributed key-value store optimized for high read volumes and low latency access from Workers.",
    category: "storage",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "cf-workers-4",
    question: "What is the execution time limit for Cloudflare Workers on the free plan?",
    options: [
      "1 second",
      "10 milliseconds CPU time",
      "60 seconds",
      "5 minutes"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "Free tier Workers have a 10ms CPU time limit per request. Paid plans offer 50ms CPU time. Wall-clock time can be longer for async operations.",
    category: "limits",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "cf-workers-5",
    question: "How do you handle POST request data in a Worker?",
    options: [
      "request.body.json()",
      "await request.json()",
      "JSON.parse(request)",
      "request.getData()"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "Workers use the standard Request API. Use await request.json() for JSON, request.text() for text, or request.formData() for forms.",
    category: "request-handling",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "cf-workers-6",
    question: "What is Durable Objects in Cloudflare Workers?",
    options: [
      "Permanent file storage",
      "Stateful objects with consistent storage and coordination",
      "Database tables",
      "Image optimization"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "hard",
    explanation: "Durable Objects provide strongly consistent storage and coordination primitives. Each object has its own storage and can maintain WebSocket connections, enabling real-time apps.",
    category: "durable-objects",
    points: 20,
    type: "multiple-choice"
  },
  {
    id: "cf-workers-7",
    question: "How does Workers caching work?",
    options: [
      "Automatic for all requests",
      "Uses Cache API to control caching behavior",
      "No caching support",
      "Only browser caching"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "Workers can use the Cache API to programmatically store and retrieve responses from Cloudflare's cache, giving fine-grained control over caching logic.",
    category: "caching",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "cf-workers-8",
    question: "What makes Workers different from traditional serverless functions?",
    options: [
      "Workers are slower",
      "Workers use isolates for instant cold starts (<1ms)",
      "Workers don't support HTTPS",
      "Workers can't access databases"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "hard",
    explanation: "Workers use V8 isolates instead of containers, providing near-instant cold starts (<1ms) and higher density. This enables running at the edge with minimal overhead.",
    category: "architecture",
    points: 20,
    type: "multiple-choice"
  }
];

export const generateCloudflareWorkersQuiz = () => ({
  questions: CLOUDFLARE_WORKERS_QUIZ,
  passThreshold: 80,
  timeLimit: 900,
  category: 'edge-computing'
});
